import { useCallback, useState } from 'react'
import ClassNames from 'classnames'

import { constants } from '../../../../componentsConstants'

import classes from './styles/cryptoPaymentInputActionButton.module.scss'
import { inputActionType } from '../cryptoPaymentInputConstants'

export const CryptoPaymentInputActionButton = ({ actionType, setFieldValue, value, inputRef, className }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = useCallback(async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value)
      } else {
        // Fallback for older browsers
        inputRef.current.select()
        document.execCommand('copy')
      }
      setCopied(true)
      setTimeout(() => setCopied(false), constants.timers['3000'])
    } catch (error) {
      console.error('Copy failed', error)
    }
  }, [inputRef, value])

  const handlePaste = useCallback(async () => {
    try {
      const text = await navigator.clipboard.readText()

      setFieldValue(text)
    } catch (err) {
      console.error('Failed to paste text from clipboard: ', err)
    }
  }, [setFieldValue])

  const componentClassName = ClassNames(classes.cryptoPaymentInputActionButton, className)

  const copyButtonClassName = ClassNames(classes.cryptoPaymentInputActionButton__icon, {
    [classes.cryptoPaymentInputActionButton__copyButtonIcon]: actionType === inputActionType.copy,
    [classes.cryptoPaymentInputActionButton__pasteButtonIcon]: actionType === inputActionType.paste,
    [classes.show]: !copied
  })

  const successButtonClassName = ClassNames(
    classes.cryptoPaymentInputActionButton__icon,
    classes.cryptoPaymentInputActionButton__successButtonIcon,
    { [classes.show]: copied }
  )

  const handleButtonClick = useCallback(() => {
    const handlers = {
      [inputActionType.copy]: handleCopy,
      [inputActionType.paste]: handlePaste
    }

    handlers[actionType]()
  }, [actionType, handleCopy, handlePaste])

  return (
    <button type="button" className={componentClassName} onClick={handleButtonClick}>
      <div className={copyButtonClassName} />
      <div className={successButtonClassName} />
    </button>
  )
}
